// @flow

export default (
  values: Object,
  hasAdminPermissions: boolean,
  t: Function,
  config: Object,
  isEditing: boolean,
) => {
  let defaultUI = {
    id: {
      "ui:title": "GoodShape ID",
      "ui:readonly": true,
      "ui:options": {
        label: t("USER_ID"),
        tooltip: {
          title: t("USER_ID"),
          description: t("FIRSTCARE_ID_TOOLTIP_TEXT"),
          id: "firstcare-id",
          size: "small",
        },
      },
    },
    hasHardOfHearing: {
      "ui:widget": "toggle",
      "ui:options": {
        tooltip: {
          title: t("HARD_OF_HEARING"),
          description: t("HARD_OF_HEARING_TOOLTIP_TEXT"),
          id: "hard-of-hearing",
          size: "small",
        },
      },
    },
    hasDisability: {
      "ui:widget": "toggle",
      "ui:options": {
        colStart: 1,
        tooltip: {
          title: t("DISABILITY"),
          description: t("DISABILITY_TOOLTIP_TEXT"),
          id: "disability",
          size: "small",
        },
      },
    },
    isNonServiceUser: {
      "ui:widget": "toggle",
      "ui:options": {
        colStart: 2,
        label: t("NON_SERVICE"),
        tooltip: {
          title: t("IS_NON_SERVICE"),
          description: t("NON_SERVICE_TOOLTIP_TEXT"),
          id: "is-non-service",
          size: "small",
        },
      },
    },
    isActive: {
      "ui:widget": "toggle",
      "ui:options": {
        disabled: true,
        tooltip: {
          title: t("STATUS"),
          description: t("ACTIVE_TOOLTIP_TEXT"),
          id: "status",
          size: "small",
        },
      },
    },
    dateOfBirth: {
      "ui:widget": "date-picker",
      "ui:options": {
        dateFormat: config.dateFormatBE,
        maxDate: values.joinDate || null,
        tooltip: {
          title: t("DATE_OF_BIRTH"),
          description: t("DOB_TOOLTIP_TEXT"),
          id: "date-of-birth",
          size: "small",
        },
        colStart: 1,
      },
    },
    joinDate: {
      "ui:widget": "date-picker",
      "ui:options": {
        dateFormat: config.dateFormatBE,
        minDate: values.dateOfBirth || null,
        label: t("START_DATE"),
        tooltip: {
          title: t("EMPLOYMENT_START_DATE"),
          description: t("EMPLOYMENT_START_DATE_TOOLTIP_TEXT"),
          id: "employment-start-date",
          size: "small",
        },
        colStart: 2,
        rowStart: 5,
      },
    },
    leaveDate: {
      "ui:widget": "date-picker",
      "ui:options": {
        dateFormat: config.dateFormatBE,
        minDate: values.joinDate ? new Date(values.joinDate) : null,
        label: t("END_DATE"),
        tooltip: {
          title: t("EMPLOYMENT_END_DATE"),
          description: t("EMPLOYMENT_END_DATE_TOOLTIP_TEXT"),
          id: "employment-end-date",
          size: "small",
        },
        colStart: 2,
        rowStart: 6,
      },
    },
    workEmail: {
      "ui:title": t("PRIMARY_EMAIL_ADDRESS"),
      "ui:options": {
        label: t("EMAIL_ADDRESS"),
        tooltip: {
          title: t("PRIMARY_EMAIL_ADDRESS"),
          description: t("PRIMARY_EMAIL_ADDRESS_TOOLTIP_TEXT"),
          id: "work-email",
          size: "small",
        },
        colStart: 3,
        rowStart: !hasAdminPermissions && 2,
      },
    },
    homeEmail: {
      "ui:title": t("SECONDARY_EMAIL_ADDRESS"),
      "ui:options": {
        label: t("BACKUP_EMAIL"),
        tooltip: {
          title: t("SECONDARY_EMAIL_ADDRESS"),
          description: t("SECONDARY_EMAIL_ADDRESS_TOOLTIP_TEXT"),
          id: "personal-email",
          size: "small",
        },
        colStart: 3,
      },
    },
    firstName: {
      "ui:options": {
        tooltip: {
          title: t("FIRST_NAME"),
          description: t("FIRST_NAME_TOOLTIP_TEXT"),
          id: "firstname",
          size: "small",
        },
      },
    },
    lastName: {
      "ui:options": {
        tooltip: {
          title: t("SURNAME"),
          description: t("SURNAME_TOOLTIP_TEXT"),
          id: "surname",
          size: "small",
        },
        colStart: 1,
      },
    },
    gender: {
      "ui:options": {
        tooltip: {
          title: t("GENDER"),
          description: t("GENDER_TOOLTIP_TEXT"),
          id: "gender",
          size: "small",
        },
        colStart: 1,
        rowStart: 5,
      },
    },
    employeeRefPrimary: {
      "ui:options": {
        tooltip: {
          title: t("EMPLOYEE_REF"),
          description: t("EMPLOYEE_REF_TOOLTIP_TEXT"),
          id: "employee-ref",
          size: "small",
        },
      },
    },
    securityNotice: {
      "ui:widget": isEditing ? "description" : "hidden",
      "ui:options": {
        hidelabel: true,
        icon: "lock",
        wrapperClassName: "d-flex gap-3 bg-disabled-input pt-3 pb-3 pl-2 pr-2 border-1px-grey br-8",
        iconClassName: "fs-50",
        colStart: 3,
        rowStart: 7,
      },
    },
    employeeRefSecondary: {
      "ui:options": {
        tooltip: {
          title: t("SECONDARY_REF"),
          description: t("SECONDARY_REF_TOOLTIP_TEXT"),
          id: "secondary-ref",
          size: "small",
        },
      },
    },
    employmentTypeId: {
      "ui:options": {
        label: t("CONTRACT_TYPE"),
        tooltip: {
          title: t("EMPLOYMENT_TYPE"),
          description: t("EMPLOYEE_TYPE_TOOLTIP_TEXT"),
          id: "employment-type",
          size: "small",
        },
      },
    },
    question: {
      "ui:options": {
        label: t("QUESTION"),
        tooltip: {
          title: t("SECURITY_QUESTION_FIELD"),
          description: t("SECURITY_QUESTION_TOOLTIP_TEXT"),
          id: "security-question",
          size: "small",
        },
      },
    },
    answer: {
      "ui:options": {
        colStart: 2,
        label: t("ANSWER"),
        tooltip: {
          title: t("SECURITY_ANSWER"),
          description: t("SECURITY_ANSWER_TOOLTIP_TEXT"),
          id: "security-answer",
          size: "small",
        },
      },
    },
    homeLandline: {
      "ui:options": {
        label: t("LAND_PHONE"),
        tooltip: {
          title: t("PERSONAL_HOME_PHONE"),
          description: t("HOME_PHONE_TOOLTIP_TEXT"),
          id: "home-phone",
          size: "small",
        },
      },
    },
    homeMobile: {
      "ui:options": {
        label: t("MOBILE_PHONE"),
        tooltip: {
          title: t("MOBILE_PHONE"),
          description: t("MOBILE_PHONE_TOOLTIP_TEXT"),
          id: "mobile-phone",
          size: "small",
        },
        colStart: 3,
      },
    },
    notificationMobile: {
      "ui:options": {
        label: t("WORK_PHONE"),
        tooltip: {
          title: t("WORK_PHONE_FOR_NOTIFICATIONS"),
          description: t("WORK_PHONE_TOOLTIP_TEXT"),
          id: "work-phone",
          size: "small",
        },
      },
    },
    "ui:order": [
      "id",
      "employeeRefPrimary",
      "notificationMobile",
      "firstName",
      "employeeRefSecondary",
      "homeMobile",
      "lastName",
      "isActive",
      "homeLandline",
      "dateOfBirth",
      "employmentTypeId",
      "workEmail",
      "gender",
      "joinDate",
      "homeEmail",
      "hasHardOfHearing",
      "leaveDate",

      "hasDisability",
      "question",
      "answer",
      "isNonServiceUser",
      "*",
    ],
  };

  if (!hasAdminPermissions) {
    defaultUI = {
      ...defaultUI,
      question: {
        "ui:widget": "hidden",
      },
      answer: {
        "ui:widget": "hidden",
      },
      hasHardOfHearing: {
        "ui:widget": "hidden",
      },
      hasDisability: {
        "ui:widget": "hidden",
      },
      isNonServiceUser: {
        "ui:widget": "hidden",
      },
      homeEmail: {
        "ui:widget": "hidden",
      },
      homeLandline: {
        "ui:widget": "hidden",
      },
      homeMobile: {
        "ui:widget": "hidden",
      },
    };
  }

  return defaultUI;
};
